<template>
  <v-sidebar v-model:visible="display" position="right" :showCloseIcon="true"
             style = "width: 21.5rem;"
             :baseZIndex="1000" :header="$t('notifications')" class="layout-config p-sidebar-sm p-0">
    <div class="layout-config-panel flex flex-column">
      <hr class="mb-0 mt-0" />
      <div v-if="notifications.length > 0" class="notification-list">
        <ul class="layout-topbar-action-panel shadow-6">
          <li class="mb-3">
            <span class="px-3 fs-small">You have <b>{{ notifications.length }}</b> new notifications</span>
          </li>
          <li v-for="(notification, index) in notifications" :key="index" class="layout-topbar-action-item">
            <div class="flex flex-row align-items-center">
              <img src="demo/images/avatar/amyelsner.png"/>
              <div class="flex flex-column" :class="{'ml-3': !isRTL, 'mr-3': isRTL}" style="flex-grow: 1;">
                <div class="flex align-items-center justify-content-between mb-1">
                  <span class="fs-small font-bold">{{ notification.title }}</span>
                  <small>{{ notification.time }}</small>
                </div>
                <span class="fs-small">{{ notification.body }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else style="height: 91% !important;" class="relative align-items-stretch flex flex-column align-content-center justify-content-center">
        <div class="flex align-self-center align-items-center justify-content-center mb-6">
          <img  src="/layout/images/push.svg"  style="height: 10rem">
        </div>
        <div class="flex align-items-center justify-content-center text-center">
            <span style="font-size: 1.2rem">
              {{ $t('no_content') }}
            </span>
          <br/>
        </div>
      </div>
    </div>
  </v-sidebar>
</template>

<script>
import vSidebar from "@/primevue/sidebar/Sidebar.vue"
import { getMessaging, onMessage, getToken } from 'firebase/messaging';

export default {
  name: "NotificationSidebar",
  data() {
    return {
      display: false,
      notifications: [], // to store notifications
    }
  },
  components:{vSidebar},
  methods:{
    openModal(){
      this.display = true
    }
  },
  mounted() {

    const messaging = getMessaging(this.$firebaseApp);

    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        // get token
        getToken(messaging).then((token) => {
          console.log(token);

          // Send this token to your server
          // axios.post('/api/save-token', { token: token })...
        });
      } else {
        console.log('Permission not granted');
      }
    }).catch((err) => {
      console.log('Permission request denied', err);
    });


    onMessage(messaging, (payload) => {
      console.log('Message received', payload);
      let timestamp = payload.data ? payload.data.timestamp : null;
      let notificationTime = timestamp ? new Date(timestamp).toLocaleTimeString() : new Date().toLocaleTimeString();

      this.notifications.unshift({
        title: payload.notification.title,
        body: payload.notification.body,
        time: notificationTime
      });
    });
  }

}
</script>

<style scoped>

</style>
